import {
  BaseCard,
  BaseNav,
  buildNavItemFromRoute,
  buildRoute,
  RouteItem,
  RouteError,
  useNavItemStore
} from '@invara-dev/react-base';
import { RouteObject } from 'react-router-dom';
import { Layout } from '../components/layout/layout';
import {
  AccountManagementItems,
  CustomerItems,
  LoginRouteItem,
  LogoutRouteItem,
  MyAccountRouteItem
} from './AccountRoutes';
import { AdminRoutes } from './AdminRoutes';
import { CleaningAdminRoutes } from './CleaningAdminRoutes';
import { CleaningRoutes, MyScheduleRoute } from './CleaningRoutes';
import { SchedulingRoutes } from './SchedulingRoutes';
import { CrmRoutes } from './CrmRoutes';

export const AuthenticatedRouteItems = [
  AccountManagementItems,
  MyAccountRouteItem,
  LogoutRouteItem,
  MyScheduleRoute,
  CleaningRoutes,
  CleaningAdminRoutes,
  SchedulingRoutes,
  CrmRoutes,
  AdminRoutes
];

export const UnauthenticatedRouteItems = [LoginRouteItem, AccountManagementItems, CustomerItems];

function getMenuAllowedRoles(subItems: BaseNav.NavItem[]) {
  const roleSets = subItems.map((item) => item.allowedRoles).filter((roles): roles is string[] => roles !== undefined);

  if (roleSets.length === 0) {
    return undefined;
  }

  if (roleSets.some((roles) => roles.length === 0)) {
    return [];
  }

  return Array.from(new Set(roleSets.flat()));
}

function buildVisibleNavItemFromRoute(routeItem: RouteItem) {
  const navItem = buildNavItemFromRoute(routeItem);

  if (!navItem || !navItem.subItems) {
    return navItem;
  }

  const subItems = navItem.subItems.filter((subItem) => !subItem.disableDefaultRender);

  return {
    ...navItem,
    subItems,
    allowedRoles: getMenuAllowedRoles(subItems) ?? navItem.allowedRoles
  } as BaseNav.NavItem;
}

export function useNavWithRouting() {
  const setNavItemStore = useNavItemStore((state) => state.set);
  const routes = new Array<RouteObject>();
  const nav: BaseNav.NavItem[] = [];

  routes.push({
    path: '/',
    element: <Layout />,
    errorElement: <RouteError />,
    children: [
      {
        path: '/',
        element: <BaseCard header={'Welcome to the MopSpot Hub.'}></BaseCard>,
        errorElement: <RouteError />
      }
    ]
  });

  AuthenticatedRouteItems.forEach((value) => {
    routes.push(buildRoute(value));
    const navItem = buildVisibleNavItemFromRoute(value);
    if (navItem) {
      nav.push(navItem);
    }
  });

  UnauthenticatedRouteItems.forEach((value) => {
    routes.push(buildRoute(value));
    const navItem = buildVisibleNavItemFromRoute(value);
    if (navItem) {
      nav.push(navItem);
    }
  });

  setNavItemStore(nav);

  return routes;
}
